export default __webpack_public_path__ + "static/safecheck-placeholder-4d6892db4680c6edd78c81d009ef2630.png";